import { useInfiniteQuery } from 'react-query';

import { Role } from 'views/App/Portal/LexID/Roles/_types/role';
import { ApiCollectionResponse } from 'types/api_response';
import {
  baseApiUrl,
  fetcher,
  infiniteEmptyResults,
  ServerErrorResponse,
  createParamString,
} from 'data_sources/constants';

export default function useRoles<T extends Role>(
  organizationId: string,
  params = {},
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/admin-role/v1/organizations/${organizationId}/roles`;

  return useInfiniteQuery<ApiCollectionResponse<T>, ServerErrorResponse>(
    ['organization_roles', organizationId, params],
    async ({ pageParam, signal }): Promise<ApiCollectionResponse<T>> => {
      try {
        const paramString = createParamString(params);
        const data: ApiCollectionResponse<T> = await fetcher({
          method: 'get',
          url: pageParam || `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      getNextPageParam: (lastPage) => {
        if (lastPage.offset && lastPage.offset < (lastPage.count || 0) && lastPage.content.length > 0) {
          const paramString = createParamString({
            ...params,
            offset: lastPage.offset,
          });
          return `${url}?${paramString}`;
        }
      },
      ...options,
    }
  );
}
